// Layout
import React from 'react';
import { MainShoppingCart } from '../../layouts/MainShoppingCart/MainShoppingCart'

export const ShoppingCart = () => {
  return (
    <MainShoppingCart />
  )
}
